var updateFilterAccessibility = require('./update-filter-accessibility');

module.exports = function ($searchRendering) {
    var handleFilterToggleClick = function(clickTarget, filterWrapperSelector)
    {
        $closestExpandableFilter = $(clickTarget).closest('.search-rendering__filter--expandable')
        $closestExpandableFilter.toggleClass('search-rendering__filter--expanded');
        if (!$closestExpandableFilter.hasClass('search-rendering__filter--expanded')) {            
            $closestExpandableFilter.find('.search-rendering__filter--expandable').removeClass('search-rendering__filter--expanded');
        }
        updateFilterAccessibility($(clickTarget).closest(filterWrapperSelector));
    };

    $searchRendering.on('click', '.search-rendering__filter--expandable > div > .search-rendering__filter-toggle', function (e) {
        handleFilterToggleClick(e.target, '.search-rendering__filters-wrapper');        
    });

    $('body').on('click', '.search-rendering__modaal-filters .search-rendering__filter--expandable > div > .search-rendering__filter-toggle', function (e) {        
        handleFilterToggleClick(e.target, '.modaal-content-container');        
    });
};